import { render } from "./UserLimits.vue?vue&type=template&id=ace80eb6&scoped=true"
import script from "./UserLimits.vue?vue&type=script&lang=js"
export * from "./UserLimits.vue?vue&type=script&lang=js"

import "./UserLimits.vue?vue&type=style&index=0&id=ace80eb6&lang=less&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace80eb6"]])

export default __exports__